import { Ref, MutableRefObject, useCallback } from 'react';

type FinalRef<T> = Ref<T> | MutableRefObject<T>;

function setRef<T>(ref: FinalRef<T>, value: T) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    // eslint-disable-next-line no-param-reassign
    (ref as MutableRefObject<T>).current = value;
  }
}

export default function useForkRef<T>(
  refs: [FinalRef<T>, FinalRef<T>, ...FinalRef<T>[]],
): React.RefCallback<T> {
  return useCallback((refValue: T) => {
    refs.forEach((ref) => setRef(ref, refValue));
  }, refs);
}
